<template>
	<section class="page page-extras-handicapper">
		<!-- Do nothing -->
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageExtrasHandicapper extends PageBase {}
</script>

<style lang="scss">
	.page-extras-handicapper {
		// Not implemented
	}
</style>
